import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { ScopeSelectKeys } from 'legacy/lut/components/widgets/public/partner360/composedReport'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import {
  selectIsShowScopeSection,
  selectPartnersInScope,
  selectScopeSelectValue,
  toggleScopeExpanding,
} from 'legacy/lut/features/partner360/composedReport'
import { selectIsOpenScopeEditor } from 'legacy/lut/features/partner360/composedReport/selectors/selectIsOpenScopeEditor'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import MeasureController from 'core/analytics/MeasureController'

import { ScopeSection } from './scopeSection/ScopeSection'

import styles from './Scope.module.scss'

interface IProps {
  metrics: MeasureController
}

export const Scope = ({ metrics }: IProps) => {
  const isShowScopeSection = useSelector(selectIsShowScopeSection)
  const partnersInScope = useSelector(selectPartnersInScope)
  const isOpenScopeEditor = useSelector(selectIsOpenScopeEditor)
  const scopeSelectValue = useSelector(selectScopeSelectValue)
  const dispatch = useDispatch()

  const expandScope = useCallback(() => {
    dispatch(toggleScopeExpanding())
  }, [dispatch])

  if (!isShowScopeSection) {
    return null
  }

  if (scopeSelectValue === ScopeSelectKeys.ManualGlobal) {
    return <ScopeSection metrics={metrics} />
  }

  return (
    <div className={styles.root}>
      <div className={styles.label}>
        <Translation
          replaceParams={[{ key: '{scope}', value: String(partnersInScope.length) }]}
          text={TRANSLATION_KEYS.partnersInScope}
        />
        <Button
          iconButton={isOpenScopeEditor ? 'kbase kbase-caret-down' : 'kbase kbase-caret-right'}
          onClick={expandScope}
          variant={'text'}
        />
      </div>
      <RenderWhen condition={isOpenScopeEditor}>
        <ScopeSection metrics={metrics} />
      </RenderWhen>
    </div>
  )
}
